import LoanPaymentInformationService from "@/services/v2/nwapp/loanPaymentInformation.service";

export const loanPaymentInformationApi = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    downloadNachaFile({ commit }, {fileDataId, loanPaymentId}) {
      return LoanPaymentInformationService.downloadNachaFile(
        fileDataId,
        loanPaymentId
      ).then(
        (resp) => {
          commit(
            "dummyConsole",
            "LoanPaymentInformationService.downloadNachaFile - success"
          );
          return Promise.resolve(resp);
        },
        (error) => {
          commit(
            "dummyConsole",
            "LoanPaymentInformationService.downloadNachaFile - error"
          );
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {
    dummyConsole(state, obj) {
      console.log(obj);
    },
  },
};
